import React from 'react';
import './Directors.css';
import rohitImage from '../assets/rohitImage.png';
import ganeshImage from '../assets/ganeshImage.png';
import deepkaImage from '../assets/deepakImage.png';
import puranMalImage from '../assets/puranMalSharma.jpeg';

const Directors = () => {
  const directors = [
    {
      id: 1,
      name: 'Mr. Rohit Sharma',
      position: 'Managing Director',
      qualifications: 'Chartered Accountant and Company Secretary',
      experience: 'Over 12 years of experience in finance, audit, and accounting',
      description: 'Instrumental in ensuring sound financial management and strategic planning.',
      image: rohitImage
    },
    {
      id: 2,
      name: 'Mr. Ganesh Sharma',
      position: 'Director',
      qualifications: 'MBA and B.E. in Electrical Engineering',
      experience: 'Over 7 years of experience in management and technology',
      description: 'Specialized woven sack industry training with expertise in financial management and technology integration.',
      image: ganeshImage,
      flip: true
    },  
    {
      id: 3,
      name: 'Mr. Deepak Sharma',
      position: 'Director',
      qualifications: 'Seasoned Professional',
      experience: 'Over 31 years of diverse experience',
      description: 'His background in the rice processing industry provides deep knowledge of the packaging supply chain.',
      image: deepkaImage
    },
    {
      id: 4,
      name: 'Mr. Puran Mal Sharma',
      position: 'Individual Promoter',
      experience: 'Over 40 years in industrial management and business operations',
      description: "A founding associate of the Maharaja Group, instrumental in establishing Maharaja Polyfab Limited and overseeing operations at Maharaja Hotel.",
      image: puranMalImage
    }
  ];

  const independentDirectors = [
    {
      id: 1,
      name: 'Mr. Jitendriya Mohanty',
      position: 'Independent Director',
      qualifications: 'FCS, ACMA, LL.M',
      experience: 'Over 15 years of expertise in corporate governance, legal advisory, and financial strategy',
      description:
        'A dual-qualified Fellow Company Secretary and Cost Accountant, he provides the Board with rigorous oversight in regulatory compliance, risk management, and fiscal discipline. His extensive background across listed entities and public sector undertakings enables him to drive high standards of transparency and ethical leadership. Currently an Associate Partner at Mehta & Mehta, he leverages his multi-disciplinary skills to support the company\'s long-term strategic growth and stakeholder value.'
    },
    {
      id: 2,
      name: 'Dr. Sudhir Kumar Das',
      position: 'Independent Director',
      qualifications: 'PhD (Management), MBA, B. Tech',
      experience: 'Over 25 years of global strategic leadership across steel, power, and infrastructure',
      description:
        'He specializes in Business Excellence Models and organizational transformation for industry leaders such as Tata Steel and GMR. His expertise spans business strategy, project management, and operational performance, providing the Board with high-level insight into scalable growth and process efficiency. A bestselling author and renowned consultant, Dr. Das integrates academic rigor with deep industrial experience to drive corporate excellence and strategic oversight.'
    },
    {
      id: 3,
      name: 'CA Sagarika Mishra',
      position: 'Independent Director',
      qualifications: 'FCA, LLB, DISA',
      experience: 'Over two decades of expertise in auditing, taxation, and insolvency law',
      description:
        'A Fellow Chartered Accountant and registered Insolvency Professional, she holds a specialized Diploma in Information System Audit and is a certified Peer Reviewer by the ICAI. Her portfolio includes acting as an Authorized Representative before the NCLT and providing strategic consultancy on the Companies Act and Bankruptcy Code. As a member of the Independent Director\'s Databank (IICA), she ensures the highest standards of corporate governance, financial integrity, and regulatory compliance for the Board.'
    }
  ];

  return (
    <section id="directors" className="directors section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Our Directors</h2>
          <p className="section-subtitle">
            Leadership team driving Maharaja Polyfab's vision and growth
          </p>
        </div>

        <div className="directors-grid">
          {directors.map(director => (
            <div key={director.id} className="director-card">
              <div className="director-image">
                {director.image ? (
                  <img
                    src={director.image}
                    alt={director.name}
                    className={`director-photo${director.flip ? ' director-photo-flip' : ''}`}
                  />
                ) : (
                  <div className="director-photo-placeholder">
                    {director.name
                      .replace(/^(Mr\.|Mrs\.|Ms\.|Dr\.|CA)\s+/i, '')
                      .split(' ')
                      .map(n => n[0])
                      .join('')
                      .slice(0, 2)
                      .toUpperCase()}
                  </div>
                )}
              </div>
              <div className="director-content">
                <h3 className="director-name">{director.name}</h3>
                <h4 className="director-position">{director.position}</h4>
                {director.qualifications && (
                  <div className="director-qualifications">
                    <i className="fas fa-graduation-cap"></i>
                    <span>{director.qualifications}</span>
                  </div>
                )}
                <div className="director-experience">
                  <i className="fas fa-briefcase"></i>
                  <span>{director.experience}</span>
                </div>
                <p className="director-description">{director.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="independent-directors">
          <div className="section-header text-center">
            <h2 className="section-title">Independent Directors</h2>
            <p className="section-subtitle">
              Independent oversight that strengthens governance and long-term value creation
            </p>
          </div>

          <div className="independent-directors-grid">
            {independentDirectors.map(director => (
              <div key={director.id} className="director-card independent-director-card">
                <div className="director-content independent-director-content">
                  <h3 className="director-name">{director.name}</h3>
                  <h4 className="director-position">{director.position}</h4>

                  <div className="director-qualifications">
                    <i className="fas fa-graduation-cap"></i>
                    <span>{director.qualifications}</span>
                  </div>

                  <div className="director-experience">
                    <i className="fas fa-briefcase"></i>
                    <span>{director.experience}</span>
                  </div>

                  <p className="director-description">{director.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Directors;
